import { CircularProgress, Typography } from "@mui/material";

import CustomIconButton from "../../../../../ui library/components/buttons/CustomIconButton";
import HNSColors from "../../../../../ui library/HNSColors";
import Divider from "../Divider";

import FollowUpHistoryListItem from "./FollowUpHistoryListItem";

export default function FollowUpHistoryList({ isLoading, data, showMore, handleShowMore }) {
  return (
    <>
      {isLoading ? (
        <div className="flex flex-1 items-center justify-center">
          <CircularProgress style={{ color: HNSColors.secondary[500] }} />
        </div>
      ) : !data || data.length === 0 ? (
        <div className="flex flex-1 items-center justify-center">
          <Typography className="text-center">Nothing to show</Typography>
        </div>
      ) : (
        <div className="absolute bottom-0 top-0 flex w-full flex-col overflow-y-auto p-2 [&::-webkit-scrollbar-thumb]:bg-blue-700 [&::-webkit-scrollbar]:[width:6px]">
          <div className="flex h-full flex-col gap-1">
            {Array.isArray(data) &&
              data.map((followUp, index) => (
                <>
                  <FollowUpHistoryListItem data={followUp} />
                  {index !== data.length - 1 && <Divider />}
                </>
              ))}
            <CustomIconButton iconVisible={showMore} handleOnClick={handleShowMore} />
          </div>
        </div>
      )}
    </>
  );
}
